import DataTable from './data-table.connect'
import { HeaderItem, RowItem } from './data-table.styles'

export {
  RowItem,
  HeaderItem
}

export default DataTable
